module.exports = __webpack_public_path__ + "img/agenda.10915360.png";